import { render, staticRenderFns } from "./ProgramarTutoriaPage.vue?vue&type=template&id=0b767845&scoped=true&"
import script from "./ProgramarTutoriaPage.vue?vue&type=script&lang=js&"
export * from "./ProgramarTutoriaPage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/shared-forms.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "../../assets/styles/shared-scheduling.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./ProgramarTutoriaPage.vue?vue&type=style&index=2&id=0b767845&prod&scoped=true&lang=css&"
import style3 from "../../assets/styles/shared-modals.css?vue&type=style&index=3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b767845",
  null
  
)

export default component.exports